// extracted by mini-css-extract-plugin
export default {"wrapper":"WgBanner_wrapper__2Z8ye"};